<template>
  <div>
    <!-- <van-nav-bar left-arrow @click-left="onClickLeft">
      <template #title>
        <van-icon name="search" size="18" />
      </template>
    </van-nav-bar> -->
    <van-nav-bar
      left-arrow
      @click-left="onClickLeft"
    >
      <template #left>
        <img
          src="../assets/img/pet-info/editinfo-left-icon.png"
          alt=""
        />
      </template>
      <template #title>
        <a href="https://pawaiipets.com">
          <img
            src="../assets/img/pet-info/pawaii-logo.png"
            alt=""
          />
        </a>
      </template>
    </van-nav-bar>
    <van-index-bar :index-list="petFilterFirstName">
      <div
        v-for="(item, index) in petFilterFirstName"
        :key="index"
      >
        <van-index-anchor :index="item" />
        <span
          v-for="(content, index) in petsList"
          :key="index"
        >
          <van-cell
            v-if="
              content.pet_name.trim().substr(0, 1).toUpperCase() == item
                ? true
                : false
            "
            @click="getPetName(content)"
            :title="
              content.pet_name
                .trim()
                .replace(content.pet_name[0], content.pet_name[0].toUpperCase())
            "
          />
        </span>
      </div>
    </van-index-bar>
  </div>
</template>

<script>
export default {
  name: "SelectPet",
  data() {
    return {
      petsList: [],
      petFirstName: [],
      petFilterFirstName: [],
    };
  },
  mounted() {
    // 获取宠物信息并处理索引列表
    this.getPetInfo();
  },
  methods: {
    // 获取宠物信息并处理索引列表
    async getPetInfo() {
      const { data: res } = await this.$http.get("/pets");
      if (res.status !== 200) return;
      this.petsList = res.data;
      // 处理索引列表
      this.petsList.forEach((value) => {
        this.petFirstName.push(
          value.pet_name.trim().substr(0, 1).toUpperCase()
        );
      });
      this.petFirstName.sort();
      // 去重
      this.petFilterFirstName = this.petFirstName.filter((value, index) => {
        return this.petFirstName.indexOf(value) === index;
      });
    },
    // 导航栏左上角点击
    onClickLeft() {
      this.$router.go(-1);
    },
    // 对应跳转
    getPetName(petinfo) {
      window.sessionStorage.setItem("usersSelectInfo", JSON.stringify(petinfo));
      this.$router.push({
        path: "/petinfo",
      });
    },
  },
};
</script>

<style scoped>
.van-nav-bar {
  background-color: #1a1a1a;
}
.van-nav-bar__title img {
  padding-top: 5px;
  width: 50px;
}
.van-nav-bar__left img {
  width: 24px;
}
.van-nav-bar__right img {
  width: 24px;
}
.van-index-bar >>> .van-index-anchor {
  background-color: #eee;
  height: 26px;
  line-height: 26px;
}
.van-cell {
  height: 40px;
}
.van-cell__title {
  font-weight: normal;
  font-size: 18px;
  line-height: 20px;
  font-family: Poppins-Regular;
}
</style>